import * as Actions from 'store/actions/app/credit_notes.actions'

const initialState = {
  loading_credit_notes: false,
  credit_notes: [],
  total_credit_notes: 0,

  loading_accounting_credit_notes: false,
  accounting_credit_notes: [],
  totals_accounting_credit_notes: null,
}

const creditNotesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_CREDIT_NOTES: {
      return {
        ...state,
        loading_credit_notes: action.payload.loading ?? state.loading_credit_notes,
        credit_notes: action.payload.items ?? state.credit_notes,
        total_credit_notes: action.payload.total ?? state.total_credit_notes,
      }
    }
    case Actions.GET_ACCOUNTING_CREDIT_NOTES: {
      return {
        ...state,
        loading_accounting_credit_notes: action.payload.loading ?? state.loading_accounting_credit_notes,
        accounting_credit_notes: action.payload.items ?? state.accounting_credit_notes,
        totals_accounting_credit_notes: action.payload.totals ?? state.totals_accounting_credit_notes,
      }
    }
    default: {
      return state
    }
  }
}

export default creditNotesReducer
